export const FACILITY_COPY = {
	title: {
		add: 'Add facility',
		edit: 'Edit facility',
	},
	submit: {
		add: 'Add',
		edit: 'Save',
	},
	description:
		'Capture the details inspectors expect to see on §607 facility registrations and audit-ready SOPs.',
	fields: {
		nameLabel: 'What is the name of this facility?',
		typeLabel: 'Is this an owned site or a contract partner?',
		registrationStatusLabel: 'What is the MoCRA registration status?',
		feiStatusLabel: 'What is the FEI status?',
		feiNumberLabel: 'What is the FEI number?',
		addressLabel: "What is the facility's address?",
		addressEmptyHint:
			'Add the facility address so recalls and registrations keep their mailing details aligned.',
	},
	actions: {
		addAddress: 'Add address',
		editAddress: 'Edit address',
		removeFacilityConfirmTitle: 'Remove this facility?',
		removeFacilityConfirmDescription:
			'This facility will be removed from the roster. You can add it again later.',
	},
	summary: {
		feiMissing: 'FEI: Not provisioned',
	},
}
